import { render, staticRenderFns } from "./makeUpExamEntry.vue?vue&type=template&id=a2bda3d8"
import script from "./makeUpExamEntry.vue?vue&type=script&lang=js"
export * from "./makeUpExamEntry.vue?vue&type=script&lang=js"
import style0 from "./makeUpExamEntry.vue?vue&type=style&index=0&id=a2bda3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports